export const eventTypeThemeColors = [
  '#1F74F2',
  '#00A7EE',
  '#00A41A',
  '#FABA16',
  '#FE820F',
  '#E51919',
  '#E80061',
  '#612FED',
];
